var socialButtons = function () {
    var scope = ".js-social-buttons";

    var fbStatus;
    var fbUser;
    window.fbAsyncInit = function () {
        FB.init({
            appId: 360665658391784,
            cookie: true,
            xfbml: true,
            version: 'v8.0'
        });
        FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    ui.ready(
        scope,
        function ($buttons) {
            var gButton = document.getElementsByClassName("abcRioButton");

            function hideInputs() {
                var name = $("[data-name='name']");
                var email = $("[data-name='email']");
                var pass = $("[data-name='pass']");
                var pass = $("[data-name='password']");
                var submitButton = $("[class='p-10']");
                name.hide();
                email.hide();
                pass.hide();
                submitButton.hide();
            }

            $buttons.find(scope + "__fb-user").change(
                function (ev) {
                    if ($buttons.find(scope + "__fb-user").val() != "") {
                        var user = JSON.parse($buttons.find(scope + "__fb-user").val());
                        var action = $buttons.find(scope + "__fb-user").data("action");
                        if (action == "login") {
                            facebookLogin(user);
                        } else {
                            var prPolicyCheck = $("[name='acceptPrivatePolicy']:checked").length;
                            hideInputs();
                            var emailPromoCheck = $("[name='enablePromos']:checked").length;
                            facebookRegister(user, prPolicyCheck, emailPromoCheck);
                        }
                    }
                });


            $buttons.find(scope + "__login-fb.login").click(
                function (ev) {
                    checkLoginState("login");
                });

            $buttons.find(scope + "__login-fb.registration").click(
                function (ev) {
                    ev.preventDefault();
                    checkLoginState("registration");
                }
            );

            function facebookRegister(user, prPolicyCheck, emailPromoCheck) {
                gvf.endpoint(
                    "web\\registrationController::newFacebookAccount",
                    [user, prPolicyCheck, emailPromoCheck],
                    function (response) {
                        if (response.status == "ok") {
                            window.location = response.url;
                        } else {
                            utils.alertEndpointResponse(response);
                        }
                    }
                );
            }

            function facebookLogin(user) {
                gvf.endpoint(
                    "web\\loginController::facebookLogin",
                    [user],
                    function (response) {
                        if (response.status == "ok" && $buttons.data("redirectUrl")) {
                            window.location = $buttons.data("redirectUrl");
                        }else if (response.status == "ok") {
                            window.location = response.url;
                        } else {
                            utils.alertEndpointResponse(response);
                        }
                    }
                );
            }

            function getUser(action) {
                FB.api(
                    '/me',
                    'GET',
                    {"fields": "id,email,first_name,last_name"},
                    function (response) {
                        fbUser = response;
                        var $input = $buttons.find(scope + "__fb-user");
                        $input.val(JSON.stringify(fbUser));
                        $input.attr("data-action", action);
                        $input.trigger('change');
                    }
                );
            }

            function checkLoginState(action) {
                FB.getLoginStatus(function (response) {
                    var fbStatus = response;
                    if (fbStatus['status'] == "connected") {
                        getUser(action);
                    } else {
                        FB.login(function (response) {
                            getUser(action);
                        },{scope: 'email'});
                    }
                });
            }

            $buttons.find(scope + "__login-g").click(
                function (ev) {
                    hideInputs();

                    function getProfile() {
                        gButton[0].click();
                        window.clicked = true;
                    }

                    function googleLogin() {
                        gvf.endpoint(
                            "web\\loginController::googleLogin",
                            [window.gprofile],
                            function (response) {
                                if (response.status == "ok" && $buttons.data("redirectUrl")) {
                                    window.location = $buttons.data("redirectUrl");
                                }else if (response.status == "ok") {
                                    window.location = response.url;
                                } else {
                                    utils.alertEndpointResponse(response);
                                }
                            }
                        );
                    }

                    function googleRegister() {

                        var prPolicyCheck = $("[name='acceptPrivatePolicy']:checked").length;
                        var emailPromoCheck = $("[name='enablePromos']:checked").length;
                        gvf.endpoint(
                            "web\\registrationController::newGoogleAccount",
                            [window.gprofile, prPolicyCheck, emailPromoCheck],
                            function (response) {
                                if (response.status == "ok") {
                                    window.location = response.url;
                                } else {
                                    utils.alertEndpointResponse(response);
                                }
                            }
                        );
                    }


                    if ($("[data-context='login']").length ==2) {
                        if (window.gprofile) {
                            googleLogin();
                        } else {
                            getProfile();
                        }
                    } else {

                        if (window.gprofile) {
                            googleRegister();
                        } else {
                            getProfile();
                        }
                    }
                }
            );
        }
    );
}();